export default __webpack_public_path__ + "static/media/akali-bg-large.88283096.jpg";